export default function (modifiers, value, notFoundValue) {
    const index = modifiers.indexOf(value);

    if (index === -1) return notFoundValue;

    const modifierValue = index + 1;

    return modifiers[modifierValue] ?? notFoundValue;
}
